<div class="row p-0 contenedor-detalle-siniestro mx-1 mt-2">
    <div class="col-md-6 col-12 borde-derecho my-3">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">PAGOS</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 my-4 overflow-auto">
                <div class="seccion-tabla">
                    <table mat-table multiTemplateDataRows [dataSource]="datosPagos.data | slice:(paginatorInfoPagos?.pageStart ? paginatorInfoPagos?.pageStart - 1 : 0):paginatorInfoPagos?.pageEnd"
                        class="table d-xl-table d-md-table d-table table-responsive my-2">
                        <ng-container matColumnDef="Tipo">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Tipo</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.desc_tipo_pago}}</td>
                        </ng-container>
                        <ng-container matColumnDef="SubTipo">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>SubTipo</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_subtipo_pago}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Importe">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Importe</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.importe}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Compañia">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Compañia</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_cia_aseg}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Folio">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Folio</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.folio}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Ref">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Ref</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">
                                <i class="fas fa-link"
                                    (click)="abrirModalVerReferencias(element, this.detalleSiniestro.responsabilidad)"></i>
                            </td>
                        </ng-container>


                        <!-- Sin resultados -->
                        <ng-container matColumnDef="noData">
                            <td mat-footer-cell *matFooterCellDef colspan="6">
                                <small>No se encontró ningún resultado</small>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="SelectRow(row, 'PAGOS')">
                        </tr>
                        <tr mat-footer-row *matFooterRowDef="['noData']"
                            [ngClass]="(datosPagos?.data?.length === 0) ? '':'ocultarPaginator'">
                        </tr>
                    </table>
                    <app-pagina-datos-tabla (eventPaginator)="paginatorInfoPagos = $event" (click)="$event.stopPropagation()"
                        [style.visibility]="datosPagos?.data?.length >= 6 ? 'visible' : 'hidden'"
                        [showFisrtLastButton]="true" [registerPerPage]="5" [totalLength]="datosPagos?.data?.length">
                    </app-pagina-datos-tabla>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-12 borde-derecho my-3">
        <div class="row borde-inferior">
            <div class="col-md-12 col-12">
                <small class="titulo">RECUPERACIONES</small>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-12 my-4 overflow-auto">
                <div class="seccion-tabla">
                    <table mat-table multiTemplateDataRows [dataSource]="datosRecuperaciones.data | slice:(paginatorInfo?.pageStart ? paginatorInfo?.pageStart - 1 : 0):paginatorInfo?.pageEnd"
                        class="table d-xl-table d-md-table d-table table-responsive my-2">
                        <ng-container matColumnDef="Tipo">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Tipo</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.desc_tipo_pago}}</td>
                        </ng-container>
                        <ng-container matColumnDef="SubTipo">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>SubTipo</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_subtipo_pago}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Importe">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Importe</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.importe}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Compañia">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Compañia</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.desc_cia_aseg}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Folio">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Folio</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">{{element?.folio}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Ref">
                            <th mat-header-cell class="px-2" *matHeaderCellDef>Ref</th>
                            <td mat-cell *matCellDef="let element" class="mx-1">
                                <i class="fas fa-link"
                                    (click)="abrirModalVerReferencias(element,  this.detalleSiniestro.responsabilidad)"></i>
                            </td>
                        </ng-container>

                        <!-- Sin resultados -->
                        <ng-container matColumnDef="noData">
                            <td mat-footer-cell *matFooterCellDef colspan="6">
                                <small>No se encontró ningún resultado</small>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns;"
                            (click)="SelectRow(row, 'RECUPERACIONES')"> </tr>
                        <tr mat-footer-row *matFooterRowDef="['noData']"
                            [ngClass]="(datosRecuperaciones?.data?.length === 0) ? '':'ocultarPaginator'"></tr>
                    </table>
                    <app-pagina-datos-tabla (eventPaginator)="paginatorInfo = $event" (click)="$event.stopPropagation()"
                        [style.visibility]="datosRecuperaciones?.data?.length >= 6 ? 'visible' : 'hidden'"
                        [showFisrtLastButton]="true" [registerPerPage]="5"
                        [totalLength]="datosRecuperaciones?.data?.length">
                    </app-pagina-datos-tabla>
                </div>
            </div>
        </div>

    </div>
</div>